export function inputHeight() {
  // 兼容 flexible
  var dpr = $('html').data('dpr'),
    fs = 36
  if (dpr && dpr > 1) {
    return dpr > 2 ? fs * 2.5 : fs * 1.5
  } else {
    return fs
  }
}

export function spaceBetween() {
  // 兼容 flexible
  var dpr = $('html').data('dpr'),
    n = 8
  if (dpr && dpr > 1) {
    return dpr > 2 ? n * 2.5 : n * 1.5
  } else {
    return n
  }
}
